/**
 * Main site JavaScript
 *
 * This file is loaded on DOM ready. Add JS modules here by using `require( 'filename' )`
 */

var MainMenu = require( './main-menu' );

MainMenu.init();


//////////////////
// WEBPACK FOOTER
// ./www/app/content/themes/rikssalsstiftelsen/static/src/js/site.js
// module id = 2
// module chunks = 0